import { render, staticRenderFns } from "./HistoryDatasetLink.vue?vue&type=template&id=84bd73d2"
import script from "./HistoryDatasetLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryDatasetLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports